module.exports = __webpack_public_path__ + "static/media/onionskinning.7c8b08c7.svg";